import { Div, RefString, SearchableItem, TextCombo } from "@tblabs/truffle";
import { SearchIcon } from "../../Components/Icons/SearchIcon";
import { Product } from "../../Models/Product/Product";
import { SearchResultItem } from "./SearchResultItem";


export class SearchBox extends Div
{
    constructor(products: Product[])
    {
        super("search");

        const data = products.map(product =>
            new SearchableItem(
                product.Title.value + " " + product.Tags.value,
                () => new SearchResultItem(product),
                () => window.location.hash = `produkt/${product.Url.value}`)
        );

        const search = new RefString();
        const searchInput = new TextCombo(search, data).Placeholder("Szukaj produktu...").FullWidth()
            .NoResultsText("Nie znaleziono produktów")

        searchInput.SearchInput.TextInput.Class("search__input");

        this.Append(
            new SearchIcon(),
            searchInput,
        );
    }
}
